import request from "@/utils/request";

export function getRoleList(params) {
  return request({
    url: "/RoleManagement/GetRoleGroupWithPaging",
    method: "get",
    params
  });
}
export function addRole(data) {
  return request({
    url: "/RoleManagement/AddRole",
    method: "post",
    data
  });
}
export function updateRole(data) {
  return request({
    url: "/RoleManagement/UpdateRole",
    method: "post",
    data
  });
}
export function deleteRole(data) {
  return request({
    url: "/RoleManagement/Delete",
    method: "delete",
    data
  });
}
export function enableRole(data) {
  return request({
    url: "/RoleManagement/EnableRole",
    method: "post",
    data
  });
}
export function getPermission(params) {
  return request({
    url: "/RoleManagement/GetPermissionTree",
    method: "get",
    params
  });
}
export function savePermission(data) {
  return request({
    url: "/RoleManagement/SavePermissionTree",
    method: "post",
    data
  });
}
export function getValidRoleGroup(params) {
  return request({
    url: "/RoleManagement/GetValidRoleGroup",
    method: "get",
    params
  });
}
export function getOperationPermission(params) {
  return request({
    url: "/RoleManagement/OperationPermission",
    method: "get",
    params
  });
}
export function saveOperationPermission(data) {
  return request({
    url: "/RoleManagement/SaveOperationPermission",
    method: "post",
    data
  });
}
export function validateModifyFeeAuth(params) {
  return request({
    url: "/RoleManagement/HostelFeeModifyAuth",
    method: "get",
    params
  });
}
